import dot from '@alife/icbu-goldlog-do-dot'
import { get as getConfig } from './config'

const MARK_SELECTOR = '[data-buyer-portrait=true]'
const MARK_FLAG_ATTR_NAME = 'data-buyer-portrait'
const INFO_SELECTOR = '[data-buyer-portrait-info]'
const INFO_ATTR_NAME = 'data-buyer-portrait-info'

export default function collect() {
  const config = getConfig()
  const { logkey } = config

  if (!logkey) {
    console.error('no logkey registered, process exit')
    return
  }

  if (!HTMLElement.prototype.getBoundingClientRect) {
    console.error(
      'the browser do not support getBoundingClientRect api, process exit'
    )
  }

  window.addEventListener('scroll', scrollHandler)
}

const delay = 300
let timer = null
function scrollHandler() {
  if (timer) {
    window.clearTimeout(timer)
    timer = null
  }

  timer = window.setTimeout(detectMarkAndDot, delay)
}

// 检测dom上的data-buyer-portrait标记
function detectMarkAndDot() {
  const $marks = document.querySelectorAll(MARK_SELECTOR)
  const viewportHeight = window.innerHeight
  const offerHeightRound = 200 // 估算offer高度为200px
  const dataArr = []

  for (let i = 0, len = $marks.length; i < len; i++) {
    const $mark = $marks[i]
    const rect = $mark.getBoundingClientRect()
    // 因为是从上往下扫描的，我们这里只处理处于视口中的dom
    if (rect.top < 0) continue
    if (rect.top > viewportHeight - offerHeightRound) break
    handleMark($mark, dataArr)

  }

  doDot(dataArr)
}

/**
 * 处理核心dom节点，并搜集其子元素中的数据
 * @param $mark HTMLElement
 * @param dataArr Array
 */
function handleMark($mark, dataArr) {
  // 将标记去除，避免之后重复选中同一个dom
  $mark.setAttribute(MARK_FLAG_ATTR_NAME, 'false')

  const markInfo = $mark.getAttribute(INFO_ATTR_NAME)
  const infoArr = []
  if (markInfo) {
    infoArr.push(markInfo)
  }

  const $infos = $mark.querySelectorAll(INFO_SELECTOR)
  $infos.forEach($info => {
    const info = $info.getAttribute(INFO_ATTR_NAME)
    info && infoArr.push(info)
  })

  dataArr.push(infoArr.join(','))
}

/**
 * 执行上报
 * @param {*} dataArr
 */
function doDot(dataArr) {
  if (dataArr.length === 0) return

  const config = getConfig()
  const { logkey } = config
  const dotStr = dataArr.join(';')
  dot(logkey, 'EXP', dotStr)
}
